import { LinkText } from 'common/src/designSystem/components/linkText';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { VolunteerRegistrationFragment } from 'common/src/generated/types';
import { isNonEmptyString } from 'common/src/util/string';
import * as React from 'react';
import { UserInformationsBarcodeModal } from '../../../users/modal/userInformationsBarcodeModal';

interface IVolunteerRegistrationBarcodeCellProps {
    volunteerRegistration: VolunteerRegistrationFragment;
}

export const VolunteerRegistrationBarcodeCell = (props: IVolunteerRegistrationBarcodeCellProps) => {
    const ticketId =
        props.volunteerRegistration.weezeventParticipantInfo?.idBarcode ??
        props.volunteerRegistration.ticketId;

    return (
        <Cell align="center" gap="2">
            <UserInformationsBarcodeModal
                nameOrEmail={props.volunteerRegistration.userInfo.nameOrEmail}
                size={30}
                ticketId={props.volunteerRegistration.ticketId}
            />

            {isNonEmptyString(props.volunteerRegistration.weezeventTicketUrl) ? (
                <LinkText
                    css={{ fontWeight: 'normal' }}
                    to={props.volunteerRegistration.weezeventTicketUrl}
                >
                    {ticketId}
                </LinkText>
            ) : (
                ticketId
            )}
        </Cell>
    );
};
